/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetModelTypesResult } from '../../models/get-model-types-result';

export interface ApiModelsTypesGet$Params {
}

export function apiModelsTypesGet(http: HttpClient, rootUrl: string, params?: ApiModelsTypesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetModelTypesResult>> {
  const rb = new RequestBuilder(rootUrl, apiModelsTypesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetModelTypesResult>;
    })
  );
}

apiModelsTypesGet.PATH = '/api/Models/types';
